import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider, createRouter } from "@tanstack/react-router";
import "./i18n";
import "./styles.css";
import { routeTree } from "./routeTree.gen";
import { ApiError } from "./lib/api";
import "./lib/session";

// Every answer that says the session ended goes to one place (lib/session.ts, through lib/api.ts), which
// shows the modal (H-g04) instead of letting each screen find out for itself. A refusal is not tried
// again; a failure at Willems once.
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: (count, err) => !(err instanceof ApiError && err.status < 500) && count < 1,
      staleTime: 30_000,
    },
    mutations: { retry: false },
  },
});

const router = createRouter({ routeTree, context: { queryClient }, defaultPreload: false });

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  </StrictMode>,
);
